import { ETH } from '../types';
export default {
  type: ETH,
  service: 'etherscan.io',
  url: 'https://api.etherscan.io/api',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
